<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px 16px 0px 16px !important;" class="todoindex" :style="conheight">
        <!-- <span class="todotitle">待办事项</span> -->
    <div class="todomenu">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="待办流程" name="todo">
                <todo  v-if="isChildUpdate1"></todo>
            </el-tab-pane>
            <el-tab-pane label="传阅给我" name="todoRead">
                <todoRead v-if="isChildUpdate2"></todoRead>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>


<script>
import todo from "@/components/flow/todo.vue";//待办
import todoRead from "@/components/flow/todoRead.vue";//待阅
  export default {
    name: "haiyaTodo",
     components: {
        todo,
        todoRead,
    },
    data() {
      return {
        activeName: 'todo',
         isChildUpdate1:true,
         isChildUpdate2:false,
         conheight: { height: window.innerHeight  + "px"},
         props: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
      };
    },
    methods: {
        handleClick(tab, event) { 
            if(tab.name == "todoRead") {//待阅
              this.isChildUpdate1 = false;
              this.isChildUpdate2 = true;
            }else{//待办
              this.isChildUpdate1 = true;
              this.isChildUpdate2 = false;
            }
        }
    },
    mounted(){
      let this_ = this;
      window.jQuery(".el-container").find(".el-main").css({"height":window.innerHeight+"px","overflow":"hidden"});
      let curr_menu = this_.$route.query.curr;
      if(curr_menu=='todoRead'){//待阅
        this_.activeName='todoRead';
        this_.isChildUpdate1 = false;
        this_.isChildUpdate2 = true;
      }else{//待办
        this_.isChildUpdate1 = true;
        this_.isChildUpdate2 = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 8px;
}


/deep/ .el-main{
  padding: 0px !important;
}
    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }



</style>
